import actions from '@/vuex/modules/pointGroupCatalog/actions'
import getters from '@/vuex/modules/pointGroupCatalog/getters'
import mutations from '@/vuex/modules/pointGroupCatalog/mutations'

const initialState = {
  pointGroupList: [],
  alertModal: {
    isShow: false,
  },
}

const pointGroupOperation = {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
}

export default pointGroupOperation
